import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ITeamInviteDTO } from "../../../../../../api-services/football/admin/manage-football-team-service";
import { manageFootballTeamService } from "../../../../../../commons";
import { StatusEnum } from "../../../../../../commons/enums/status-enum";
import { TeamStatusEnum } from "../../../../../../commons/enums/team-status-enum";

interface ITeamCompetitionInviteAcceptOption {
  teamId: number;
  inviteId: number;
  teamInviteInfo: ITeamInviteDTO;
}

interface ITeamCompetitionInviteRejectOption {
  teamId: number;
  inviteId: number;
}

interface ITeamInviteAcceptRejectState {
  teamInviteAcceptRejectStatus: StatusEnum;
}

const initialState: ITeamInviteAcceptRejectState = {
  teamInviteAcceptRejectStatus: StatusEnum.Idle,
};

export const teamInviteAccept = createAsyncThunk(
  "manage/teamInviteAccept",
  async (options: ITeamCompetitionInviteAcceptOption, thunkAPI) => {
    try {
      const teamInviteAcceptResponse = await manageFootballTeamService.acceptTeamCompetitionInvite(
        options.teamId,
        options.inviteId,
        options.teamInviteInfo
      );
      return teamInviteAcceptResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const teamInviteReject = createAsyncThunk(
  "manage/teamInviteReject",
  async (options: ITeamCompetitionInviteRejectOption, thunkAPI) => {
    try {
      const teamInviteRejectResponse = await manageFootballTeamService.rejectTeamCompetitionInvite(
        options.teamId,
        options.inviteId
      );
      return teamInviteRejectResponse;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const teamInviteAcceptRejectSlice = createSlice({
  name: "teamInviteAcceptReject",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(teamInviteAccept.pending, (state) => {
        state.teamInviteAcceptRejectStatus = StatusEnum.Loading;
      })
      .addCase(teamInviteAccept.fulfilled, (state, action) => {
        state.teamInviteAcceptRejectStatus = StatusEnum.Succeeded;
      })
      .addCase(teamInviteAccept.rejected, (state) => {
        state.teamInviteAcceptRejectStatus = StatusEnum.Failed;
      })
      .addCase(teamInviteReject.pending, (state) => {
        state.teamInviteAcceptRejectStatus = StatusEnum.Loading;
      })
      .addCase(teamInviteReject.fulfilled, (state, action) => {
        state.teamInviteAcceptRejectStatus = StatusEnum.Succeeded;
      })
      .addCase(teamInviteReject.rejected, (state) => {
        state.teamInviteAcceptRejectStatus = StatusEnum.Failed;
      });
  },
});

export default teamInviteAcceptRejectSlice.reducer;
